import { css } from 'emotion';
import {
	helvetica,
	lightGrey,
	grey,
	pink,
	museo900,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const wrapperStyle = topMargin => css({
	...helvetica,
	height: '32px',
	background: lightGrey,
	position: 'sticky',
	top: `${0 + topMargin}px`,
	zIndex: 3,
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'center',
	'& a': {
		lineHeight: '32px',
		color: grey,
		fontSize: '12px',
		textDecoration: 'none',
		display: 'inline-block',
	},
});

export const donateButtonStyle = css({
	...museo900,
	background: pink,
	border: 'none',
	color: '#fff',
	fontSize: '12px',
	lineHeight: '15px',
	letterSpacing: '0.5',
	borderRadius: '3px',
	textTransform: 'uppercase',
	padding: '5px 7px 1px 7px',
	marginLeft: '2px',
});



// WEBPACK FOOTER //
// ./src/components/shared/greyBar/styles.js